import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'
import _imports_1 from '@/assets/digithia-favicon.png'


_pushScopeId("data-v-405c7f39")
const _hoisted_1 = {
  "close-menu": "",
  class: "view",
  ref: "digUiView"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "menu-logo",
  alt: "Digithia",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "menu-logo-tiny",
  alt: "Digithia",
  src: _imports_1
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { slot: "nav-bar" }
const _hoisted_10 = {
  key: 0,
  type: "moon"
}
const _hoisted_11 = {
  key: 1,
  type: "sun"
}
const _hoisted_12 = { slot: "side-bar" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 3 }
const _hoisted_18 = {
  slot: "footer",
  class: "footer"
}
const _hoisted_19 = { class: "links" }
const _hoisted_20 = { class: "digithia" }
const _hoisted_21 = { class: "version" }
const _hoisted_22 = { class: "logged-user" }
const _hoisted_23 = { class: "contacts" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", null, "Thibert", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", null, "Sébastien", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_locale_select = _resolveComponent("base-locale-select")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("dig-ui-view", _hoisted_1, [
    _createElementVNode("dig-ui-nav-bar-item", {
      slot: "nav-bar",
      class: "no-padding-on-desktop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('/projects')))
    }, _hoisted_4),
    _createElementVNode("dig-ui-nav-bar-item", {
      slot: "nav-bar",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('/account')))
    }, [
      (!_ctx.mobile)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('myAccount')), 1))
        : _createCommentVNode("", true),
      (_ctx.mobile)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('myAccountShort')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("dig-ui-nav-bar-item", {
      slot: "nav-bar",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
    }, [
      (!_ctx.mobile)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('logout')), 1))
        : _createCommentVNode("", true),
      (_ctx.mobile)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('logoutShort')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("dig-ui-nav-bar-item", _hoisted_9, [
      _createVNode(_component_base_locale_select)
    ]),
    _createElementVNode("dig-ui-nav-bar-item", {
      slot: "nav-bar",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDarkMode()))
    }, [
      (!_ctx.darkMode)
        ? (_openBlock(), _createElementBlock("dig-ui-icon", _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.darkMode)
        ? (_openBlock(), _createElementBlock("dig-ui-icon", _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("nav", _hoisted_12, [
      _createElementVNode("dig-ui-side-bar-item", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goBack())),
        class: "side-bar-title"
      }, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('previous')), 1)
      ]),
      (_ctx.projects.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("dig-ui-side-bar-item", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goTo('/projects'))),
              class: _normalizeClass(["side-bar-title", { selected: _ctx.isSelected('projects') }])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('home')), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.projects.length === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(), _createElementBlock("dig-ui-side-bar-item", {
              key: _ctx.projects[0].id,
              class: _normalizeClass(["side-bar-title", { selected: _ctx.isSelected('projects/' + _ctx.projects[0].id) }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goTo('/projects/' + _ctx.projects[0].id)))
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.projects[0].name), 1)
            ], 2))
          ]))
        : _createCommentVNode("", true),
      (_ctx.projects.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("dig-ui-side-bar-item", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goTo('/projects'))),
              class: _normalizeClass(["side-bar-title", { selected: _ctx.isSelected('projects') }])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('projects')), 1)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
              return (_openBlock(), _createElementBlock("dig-ui-side-bar-item", {
                key: project.id,
                onClick: ($event: any) => (_ctx.goTo('/projects/' + project.id)),
                class: _normalizeClass({ selected: _ctx.isSelected('projects/' + project.id) })
              }, [
                _createElementVNode("div", null, _toDisplayString(project.name), 1)
              ], 10, _hoisted_16))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.loggedUser.role === _ctx.USER_ROLES.SUPERADMIN)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("dig-ui-side-bar-item", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goTo('/accounts'))),
              class: _normalizeClass(["side-bar-title", { selected: _ctx.isSelected('accounts') }])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('users')), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_view, { slot: "content" }),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_router_link, { to: "/projects" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('home')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/account" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('myAccount')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/projects" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('projects')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: '/projects/' + _ctx.lastProject?.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.lastProject?.name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, "Digithia Dashboard " + _toDisplayString(_ctx.version), 1),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.loggedUser.username) + " (" + _toDisplayString(_ctx.loggedUser.role) + ") ", 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('Roles.developper')) + " : ", 1),
          _hoisted_24
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('Roles.salesperson')) + " : ", 1),
          _hoisted_25
        ])
      ])
    ])
  ], 512))
}